import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {DashboardComponent} from "./dashboard.component";

@NgModule({
    declarations: [DashboardComponent],
    imports     : [BrowserModule],
})

export class DashboardModule {}


// WEBPACK FOOTER //
// ./src/app/views/dashboard/dashboard.module.ts